import { render, staticRenderFns } from "./shopping-cart-wizard-product-list-step.vue?vue&type=template&id=3921f1e2&"
import script from "./shopping-cart-wizard-product-list-step.vue?vue&type=script&lang=ts&"
export * from "./shopping-cart-wizard-product-list-step.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports